function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatRole() {
  var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var text = String(role || '').trim();
  if (!text) {
    return '';
  }
  return text.replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  });
}

/**
 * Pot contribution overlay — presentation only.
 * Data: player_names, player_pot, returnPlayerRole(), convertChipsToCrypto().
 */
module.exports = function (game_mod) {
  var pp = game_mod.game.state.player_pot || [];
  var pn = game_mod.game.state.player_names || [];
  var cryptoStaked = typeof game_mod.isCryptoStakedGame === 'function' ? game_mod.isCryptoStakedGame() : typeof game_mod.game.stake === 'string' && !!game_mod.game.crypto && game_mod.game.crypto !== 'CHIPS';
  var html = "\n  <form class=\"saito-overlay-form pot-details-overlay".concat(cryptoStaked ? ' crypto-stake' : '', "\" id=\"pot-details-overlay-root\">\n    <header class=\"saito-overlay-form-header\">\n      <h2 class=\"saito-overlay-form-header-title\">Pot Contributions</h2>\n    </header>\n\n    <div class=\"pot-details-list\">");
  for (var i = 0; i < pp.length; i++) {
    var name = escapeHtml(pn[i] || "Player ".concat(i + 1));
    var role = formatRole(game_mod.returnPlayerRole(i + 1));
    var amount = pp[i];
    var balanceHtml = typeof game_mod.returnChipCryptoBalanceHtml === 'function' ? game_mod.returnChipCryptoBalanceHtml(amount) : "".concat(amount, " ").concat(amount === 1 ? 'CHIP' : 'CHIPS');
    html += "\n      <div class=\"pot-details-row\">\n        <div class=\"pot-details-player\">\n          <div class=\"pot-details-name\">".concat(name, "</div>\n          ").concat(role ? "<div class=\"pot-details-role\">".concat(escapeHtml(role), "</div>") : "<div class=\"pot-details-role pot-details-role--empty\"></div>", "\n        </div>\n        <div class=\"pot-details-amount\">").concat(balanceHtml, "</div>\n      </div>");
  }
  html += "\n    </div>\n  </form>";
  return html;
};